 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "vue-app/js/" + ({"brindo":"brindo","brindoEn":"brindoEn"}[chunkId]||chunkId) + "." + {"brindo":"9b49bbb9","brindoEn":"7bff509b","chunk-95941e8c":"5ba35dfe","chunk-00be3c95":"8b65f29b","chunk-00d364b2":"b9b41222","chunk-02909d63":"4538428f","chunk-04f84962":"2c4f7bf4","chunk-0d3f273e":"ce46f969","chunk-0de68ef1":"609797d0","chunk-130a9f28":"3d8b77c7","chunk-136c4d91":"49579996","chunk-176a141c":"fb6476db","chunk-1aa1e602":"d56328a4","chunk-1d9a2b33":"924d99aa","chunk-29978d2d":"d4a772f5","chunk-2a385d2a":"78f35753","chunk-2bc5b83f":"152c3a77","chunk-2c47f778":"7a28b123","chunk-30f3edba":"9e83f586","chunk-3157829a":"11015c6c","chunk-32a4cdaa":"9fdd40d7","chunk-33d2a8ea":"cafdf1f2","chunk-340e3ce0":"698c793d","chunk-0092ba9f":"3bb5b46e","chunk-099cd932":"b4ed46a6","chunk-34f0d450":"75740551","chunk-42e5baa8":"6f50aec8","chunk-4e370454":"44b828a4","chunk-37befbf8":"01d8a204","chunk-3afd6df6":"a482974c","chunk-3cc1b5f2":"c8884f85","chunk-3cf55a4e":"e90351f2","chunk-3edd7164":"d86983d5","chunk-409e3846":"7ab912bf","chunk-489a5d8c":"dfc3814e","chunk-49614f87":"9eadd382","chunk-49dfa10f":"84a42531","chunk-49eadf58":"e7d701d2","chunk-4bb8e297":"0ed40893","chunk-4d685933":"c16f5613","chunk-50da4b95":"59f09bda","chunk-5158f114":"5c2dacfe","chunk-546b1de9":"b4b327c5","chunk-547654f4":"736ad756","chunk-5478e7ce":"a556de4b","chunk-551131b1":"8ea880c0","chunk-5640405b":"0025d750","chunk-6355b0e1":"83287936","chunk-660463ec":"88de8bf8","chunk-31635c18":"4a6ec127","chunk-5b8915ae":"6fb97198","chunk-5ec131ed":"36720500","chunk-64ae9c62":"9f1c09c7","chunk-71f6be9d":"668943b2","chunk-766a6332":"1f682fb0","chunk-8b0fe0f4":"19f63201","chunk-8ec5248c":"ccaaf1d0","chunk-ae6c457c":"4399bb79","chunk-e30f39da":"63934e44","chunk-690bb4d5":"310d3691","chunk-7006278c":"0837446d","chunk-7349e708":"88bc6979","chunk-7450f82c":"17cf4a69","chunk-7b76d597":"acbb8c64","chunk-7f7c450e":"e84d1274","chunk-7ffc4f32":"3091bfe7","chunk-842cd0e8":"6909a78b","chunk-85694a4c":"6ce03587","chunk-880a847a":"0132d6af","chunk-8b1f7c04":"05a2a1b4","chunk-91a133b0":"511a79d3","chunk-9ea62522":"29ea45c9","chunk-b1e9bb58":"b2272ddf","chunk-190106c8":"5817ea20","chunk-19e02a8a":"8b7bfe95","chunk-1d3d6b13":"7abd4d27","chunk-255d5171":"88bab541","chunk-26e76c41":"27d05a35","chunk-2e59a6a6":"2c5b5012","chunk-3c0272c4":"ee63cb96","chunk-5d03e430":"5c200ae4","chunk-72b66983":"74307d0c","chunk-793af397":"970e30a0","chunk-7d45ecaf":"f4d00f0c","chunk-ee0ae732":"105a9078","chunk-b6d733f2":"6ea389e3","chunk-c0b9576a":"a0cb29e9","chunk-c4dcbebc":"58861e0d","chunk-c89fa33c":"2b65682f","chunk-ce336b54":"5993771b","chunk-d0c475c8":"5b1e7c9d","chunk-220fddd2":"55154440","chunk-2770c514":"7a10aa60","chunk-33be82ca":"ffd0aca1","chunk-34ab981d":"5c9abe5b","chunk-47c331c4":"463bc48d","chunk-4f2520a7":"d1e988c9","chunk-61fdadaa":"7fe927fc","chunk-701fd880":"ae996373","chunk-75d89275":"61a02eed","chunk-765fcb4a":"0ad0747c","chunk-85bc98d0":"30fc003d","chunk-8945f53a":"a78328e0","chunk-b07f4bf0":"e2ffca1c","chunk-de651dec":"0996b15a","chunk-c44f03dc":"68a99917","chunk-d8fde494":"88d02bc4","chunk-e865ff54":"5d351286","chunk-f77d1282":"dcfbef23","chunk-e487d426":"6b18c751","chunk-e6385cba":"447af6f3","chunk-f0ca8bae":"918e81a5","chunk-f0f3bdbc":"c16729f8","chunk-f19f03f0":"45b91e9c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-95941e8c":1,"chunk-00be3c95":1,"chunk-00d364b2":1,"chunk-02909d63":1,"chunk-04f84962":1,"chunk-0d3f273e":1,"chunk-0de68ef1":1,"chunk-130a9f28":1,"chunk-136c4d91":1,"chunk-176a141c":1,"chunk-1aa1e602":1,"chunk-1d9a2b33":1,"chunk-29978d2d":1,"chunk-2a385d2a":1,"chunk-2bc5b83f":1,"chunk-2c47f778":1,"chunk-30f3edba":1,"chunk-3157829a":1,"chunk-32a4cdaa":1,"chunk-33d2a8ea":1,"chunk-340e3ce0":1,"chunk-0092ba9f":1,"chunk-099cd932":1,"chunk-34f0d450":1,"chunk-42e5baa8":1,"chunk-4e370454":1,"chunk-37befbf8":1,"chunk-3afd6df6":1,"chunk-3cc1b5f2":1,"chunk-3cf55a4e":1,"chunk-3edd7164":1,"chunk-409e3846":1,"chunk-489a5d8c":1,"chunk-49614f87":1,"chunk-49dfa10f":1,"chunk-49eadf58":1,"chunk-4bb8e297":1,"chunk-4d685933":1,"chunk-50da4b95":1,"chunk-5158f114":1,"chunk-546b1de9":1,"chunk-547654f4":1,"chunk-5478e7ce":1,"chunk-551131b1":1,"chunk-5640405b":1,"chunk-6355b0e1":1,"chunk-660463ec":1,"chunk-31635c18":1,"chunk-5b8915ae":1,"chunk-5ec131ed":1,"chunk-64ae9c62":1,"chunk-71f6be9d":1,"chunk-766a6332":1,"chunk-8b0fe0f4":1,"chunk-8ec5248c":1,"chunk-ae6c457c":1,"chunk-e30f39da":1,"chunk-690bb4d5":1,"chunk-7006278c":1,"chunk-7349e708":1,"chunk-7450f82c":1,"chunk-7b76d597":1,"chunk-7f7c450e":1,"chunk-7ffc4f32":1,"chunk-842cd0e8":1,"chunk-85694a4c":1,"chunk-880a847a":1,"chunk-8b1f7c04":1,"chunk-91a133b0":1,"chunk-9ea62522":1,"chunk-b1e9bb58":1,"chunk-190106c8":1,"chunk-19e02a8a":1,"chunk-1d3d6b13":1,"chunk-255d5171":1,"chunk-26e76c41":1,"chunk-2e59a6a6":1,"chunk-3c0272c4":1,"chunk-5d03e430":1,"chunk-72b66983":1,"chunk-793af397":1,"chunk-7d45ecaf":1,"chunk-ee0ae732":1,"chunk-b6d733f2":1,"chunk-c0b9576a":1,"chunk-c4dcbebc":1,"chunk-c89fa33c":1,"chunk-ce336b54":1,"chunk-d0c475c8":1,"chunk-220fddd2":1,"chunk-2770c514":1,"chunk-33be82ca":1,"chunk-34ab981d":1,"chunk-47c331c4":1,"chunk-4f2520a7":1,"chunk-61fdadaa":1,"chunk-701fd880":1,"chunk-75d89275":1,"chunk-765fcb4a":1,"chunk-85bc98d0":1,"chunk-8945f53a":1,"chunk-b07f4bf0":1,"chunk-de651dec":1,"chunk-c44f03dc":1,"chunk-d8fde494":1,"chunk-e865ff54":1,"chunk-f77d1282":1,"chunk-e487d426":1,"chunk-e6385cba":1,"chunk-f0ca8bae":1,"chunk-f0f3bdbc":1,"chunk-f19f03f0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "vue-app/css/" + ({"brindo":"brindo","brindoEn":"brindoEn"}[chunkId]||chunkId) + "." + {"brindo":"31d6cfe0","brindoEn":"31d6cfe0","chunk-95941e8c":"ecd72bac","chunk-00be3c95":"523bcde9","chunk-00d364b2":"523bcde9","chunk-02909d63":"523bcde9","chunk-04f84962":"523bcde9","chunk-0d3f273e":"523bcde9","chunk-0de68ef1":"523bcde9","chunk-130a9f28":"523bcde9","chunk-136c4d91":"523bcde9","chunk-176a141c":"523bcde9","chunk-1aa1e602":"523bcde9","chunk-1d9a2b33":"523bcde9","chunk-29978d2d":"523bcde9","chunk-2a385d2a":"523bcde9","chunk-2bc5b83f":"523bcde9","chunk-2c47f778":"523bcde9","chunk-30f3edba":"523bcde9","chunk-3157829a":"523bcde9","chunk-32a4cdaa":"523bcde9","chunk-33d2a8ea":"523bcde9","chunk-340e3ce0":"1ad014b6","chunk-0092ba9f":"0e433876","chunk-099cd932":"0e433876","chunk-34f0d450":"0e433876","chunk-42e5baa8":"0e433876","chunk-4e370454":"0e433876","chunk-37befbf8":"523bcde9","chunk-3afd6df6":"523bcde9","chunk-3cc1b5f2":"abf71e5a","chunk-3cf55a4e":"523bcde9","chunk-3edd7164":"523bcde9","chunk-409e3846":"523bcde9","chunk-489a5d8c":"523bcde9","chunk-49614f87":"523bcde9","chunk-49dfa10f":"523bcde9","chunk-49eadf58":"523bcde9","chunk-4bb8e297":"0e433876","chunk-4d685933":"523bcde9","chunk-50da4b95":"523bcde9","chunk-5158f114":"523bcde9","chunk-546b1de9":"523bcde9","chunk-547654f4":"523bcde9","chunk-5478e7ce":"523bcde9","chunk-551131b1":"523bcde9","chunk-5640405b":"523bcde9","chunk-6355b0e1":"523bcde9","chunk-660463ec":"ffaf235b","chunk-31635c18":"0e433876","chunk-5b8915ae":"0e433876","chunk-5ec131ed":"0e433876","chunk-64ae9c62":"0e433876","chunk-71f6be9d":"0e433876","chunk-766a6332":"0e433876","chunk-8b0fe0f4":"0e433876","chunk-8ec5248c":"0e433876","chunk-ae6c457c":"0e433876","chunk-e30f39da":"0e433876","chunk-690bb4d5":"523bcde9","chunk-7006278c":"523bcde9","chunk-7349e708":"abf71e5a","chunk-7450f82c":"523bcde9","chunk-7b76d597":"523bcde9","chunk-7f7c450e":"523bcde9","chunk-7ffc4f32":"523bcde9","chunk-842cd0e8":"523bcde9","chunk-85694a4c":"523bcde9","chunk-880a847a":"523bcde9","chunk-8b1f7c04":"523bcde9","chunk-91a133b0":"523bcde9","chunk-9ea62522":"523bcde9","chunk-b1e9bb58":"4df6b446","chunk-190106c8":"ecc0d0ee","chunk-19e02a8a":"ecc0d0ee","chunk-1d3d6b13":"e95e7fbb","chunk-255d5171":"ecc0d0ee","chunk-26e76c41":"ecc0d0ee","chunk-2e59a6a6":"ecc0d0ee","chunk-3c0272c4":"ecc0d0ee","chunk-5d03e430":"ecc0d0ee","chunk-72b66983":"ecc0d0ee","chunk-793af397":"ecc0d0ee","chunk-7d45ecaf":"ecc0d0ee","chunk-ee0ae732":"ecc0d0ee","chunk-b6d733f2":"523bcde9","chunk-c0b9576a":"523bcde9","chunk-c4dcbebc":"523bcde9","chunk-c89fa33c":"523bcde9","chunk-ce336b54":"523bcde9","chunk-d0c475c8":"065ccc22","chunk-220fddd2":"dab11bd8","chunk-2770c514":"dab11bd8","chunk-33be82ca":"dab11bd8","chunk-34ab981d":"0e433876","chunk-47c331c4":"0e433876","chunk-4f2520a7":"0e433876","chunk-61fdadaa":"0e433876","chunk-701fd880":"0e433876","chunk-75d89275":"dab11bd8","chunk-765fcb4a":"0e433876","chunk-85bc98d0":"dab11bd8","chunk-8945f53a":"dab11bd8","chunk-b07f4bf0":"dab11bd8","chunk-de651dec":"0e433876","chunk-c44f03dc":"dab11bd8","chunk-d8fde494":"dab11bd8","chunk-e865ff54":"0e433876","chunk-f77d1282":"0e433876","chunk-e487d426":"523bcde9","chunk-e6385cba":"523bcde9","chunk-f0ca8bae":"523bcde9","chunk-f0f3bdbc":"523bcde9","chunk-f19f03f0":"523bcde9"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
